import React, { useState, useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { auth, db } from '../firebase/config';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import './Dashboard.css';

const Welcome = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    loadUserData();
  }, []);

  const loadUserData = async () => {
    if (!auth.currentUser) {
      navigate('/login');
      return;
    }

    try {
      setUserName(auth.currentUser.displayName || 'User');
      setUserEmail(auth.currentUser.email || '');
      setUserRole(auth.currentUser.displayName || '');
      
      // Optional: Fetch any additional user data from Firestore if needed
      // const userDoc = await getDoc(doc(db, 'users', auth.currentUser.uid));
      // if (userDoc.exists()) {
      //   // Set additional user data
      // }
    } catch (error) {
      console.error('Error loading user data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleViewStatistics = () => {
    navigate('/statistics');
  };

  const handleViewAnalysis = () => {
    navigate('/financialanalysis');
  };

  const handleViewProject = () => {
    navigate('/projectmanagement');
  };

  const handleAccounts = () => {
    navigate('/ledgersystem');
  };

  // Check if user is CEO/manager/accountant for additional buttons
  const isCEO = userRole === 'ceo';
  const isManager = userRole === 'manager';
  const isAccountant = userRole === 'accountant';
  const isQualityControl = userRole === 'quality-control';

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-header">
          <div className="dashboard-logo">
            <div className="logo-circle">
              <span className="logo-text">KG</span>
            </div>
            <div className="logo-text-content">
              <h1>Kajja Galleries</h1>
              <p>Welcome</p>
            </div>
          </div>
        </div>
        <div className="dashboard-content">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div className="dashboard-logo">
          <div className="logo-circle">
            <span className="logo-text">KG</span>
          </div>
          <div className="logo-text-content">
            <h1>Kajja Galleries</h1>
            <p>Welcome Portal</p>
          </div>
        </div>
        <div className="header-actions">
          {isAccountant ? (
            <button onClick={handleAccounts} className="stats-btn">
              <span className="stats-icon">📊</span>
              Manage Finance
            </button>
          ) : null}
          {(isManager || isCEO) ? (
            <button onClick={handleViewStatistics} className="stats-btn">
              <span className="stats-icon">📊</span>
              View Training Statistics
            </button>
          ) : null}
          {(isManager || isCEO) ? (
            <button style={{ backgroundColor: 'blue' }} onClick={handleViewAnalysis} className="stats-btn">
              <span className="stats-icon">📊</span>
              Financial Analysis
            </button>
          ) : null}
          {(isManager || isCEO || isQualityControl) ? (
            <button style={{ backgroundColor: 'blue' }} onClick={handleViewProject} className="stats-btn">
              <span className="stats-icon">📊</span>
              Manage Project
            </button>
          ) : (
            <button style={{ backgroundColor: 'blue' }} onClick={handleViewProject} className="stats-btn">
              <span className="stats-icon">📊</span>
              My Tasks
            </button>
          )}
          <button onClick={handleLogout} className="logout-btn">
            <span className="logout-icon">🚪</span>
            Logout
          </button>
        </div>
      </div>

      <div className="dashboard-content">
        <div className="welcome-section">
          <div className="welcome-card">
            <div className="welcome-avatar">
              <span className="avatar-icon">👋</span>
            </div>
            <div className="welcome-text">
              <h2>Welcome back, {userName}!</h2>
              <p>We're glad to see you again at Kajja Galleries</p>
              <p className="role-display">
                You are logged in as a <strong>{userRole}</strong>
              </p>
            </div>
          </div>
          <div className="user-info">
            <div className="info-item">
              <span className="info-label">Email:</span>
              <span className="info-value">{userEmail}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Role:</span>
              <span className="info-value role-badge">{userRole}</span>
            </div>
            {(isCEO || isManager) && (
              <div className="info-item">
                <span className="info-label">Access:</span>
                <span className="info-value admin-badge">Administrator</span>
              </div>
            )}
          </div>
        </div>

        {/* Additional welcome content can be added here */}
        <div className="welcome-features">
          <div className="feature-cards">
            <div className="feature-card">
              <div className="feature-icon">📚</div>
              <h3>Learning Resources</h3>
              <p>Access your training materials and track your progress</p>
              <button 
                onClick={() => navigate('/dashboard')} 
                className="feature-btn"
              >
                Go to Training
              </button>
            </div>
            {isManager || isCEO?(
                <>
                   <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Performance Metrics</h3>
              <p>View your achievements and completion statistics</p>
              <button 
                onClick={handleViewStatistics} 
                className="feature-btn"
                
              >
                View Training Stats
              </button>
            </div>
                </>
            ):<></>}
            
            <div className="feature-card">
              <div className="feature-icon">💼</div>
              <h3>Task Management</h3>
              <p>Track and manage your Tasks</p>
              <button 
                onClick={handleViewProject} 
                className="feature-btn"
              >
                View Tasks
              </button>
            </div>
            {isCEO || isManager || isCEO || isQualityControl?(
                <>
                    <div className="feature-card">
              <div className="feature-icon">💼</div>
              <h3>Project Management</h3>
              <p>Track and manage your active projects</p>
              <button 
                onClick={handleViewProject}
                disabled={!isManager && !isCEO && !isQualityControl}  
                className="feature-btn"
              >
                Go to Project Management
              </button>
            </div>
                </>
            ):<></>}
            
          </div>
        </div>
      </div>

      <style jsx>{`
        .welcome-features {
          margin-top: 2rem;
          padding: 1rem;
        }
        
        .feature-cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .feature-card {
          background: white;
          border-radius: 16px;
          padding: 1.5rem;
          text-align: center;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        
        .feature-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
        }
        
        .feature-icon {
          font-size: 3rem;
          margin-bottom: 1rem;
        }
        
        .feature-card h3 {
          margin: 0 0 0.5rem 0;
          color: #333;
          font-size: 1.25rem;
        }
        
        .feature-card p {
          color: #666;
          font-size: 0.9rem;
          margin-bottom: 1.5rem;
          line-height: 1.4;
        }
        
        .feature-btn {
          background: linear-gradient(135deg, #800000, #a00000);
          color: white;
          border: none;
          padding: 0.6rem 1.2rem;
          border-radius: 8px;
          font-size: 0.9rem;
          font-weight: 500;
          cursor: pointer;
          transition: opacity 0.2s ease;
        }
        
        .feature-btn:hover:not(:disabled) {
          opacity: 0.9;
        }
        
        .feature-btn:disabled {
          background: #ccc;
          cursor: not-allowed;
        }
        
        @media (max-width: 768px) {
          .feature-cards {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default Welcome;